export default class TimeEntryEvents {
    public static readonly saved = "TimeEntry:Saved";
}
